<template>
  <div
    class="mini-calendar__pool"
    v-if="categorylist.keys ? true : false"
    role="region"
    aria-label="Search Results"
  >
  <div class="mini-calendar__pool-filters">
    <!-- Reset All for LIST VIEW -->
    <div class="mini-calendar__pool-resets" v-if="!isMonthView">
      <button
        class="mini-calendar__pool-clear-all"
        @click="onClearAll()"
        v-if="search !== '' || filter.length !== 0 || date_range.type !== ''"
      >
        Reset All
      </button>
    </div>

    <!-- Reset All for MONTH VIEW -->
    <div class="mini-calendar__pool-reset" v-else>
      <button
        class="mini-calendar__pool-clear-all"
        @click="onClearAll()"
        v-if="(search !== '' || filter.length !== 0) "
      >
        Reset All
      </button>
     </div>
      <div class="mini-calendar__pool-filters__items">
        <span
          aria-hidden="false"
          class="mini-calendar__pool-filters__item"
          v-show="search"
          @click="onClear"
          >{{ search }} <IconClose
        /></span>
        <span
          aria-hidden="false"
          class="mini-calendar__pool-filters__item"
          v-show="!isMonthView && date_range.type != '' && (!isDateManuallySelected || date_range.start != date_range.end)"
          @click="onClearDate"
          >{{ getDateFilterName }} <IconClose
        /></span>
        <!-- Single-day filter tag -->
        <span
        aria-hidden="false"
        class="mini-calendar__pool-filters__item"
        v-show="!isMonthView && date_range.type != '' && isDateManuallySelected && date_range.start == date_range.end"
        @click="onClearDate"
        >{{ getDateFilterName }}<IconClose />
        </span>
        <span
          v-show="filter.length != 0"
          class="mini-calendar__pool-filters__item"
          @click="onRemoveFilter(item)"
          v-for="item in filter"
          :key="item"
          >{{ getCategoryName(item) }} <IconClose
        /></span>
      </div>

    </div>
    <div class="mini-calendar__pool-result" v-show="!isMonthView && total >= 0 && eventlist.length > 0">
      Showing <b>{{ eventlist.length }}</b> of <b>{{ total }}</b> events
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import {  getFilteredEvents } from "./../api";
import IconClose from "./icon/icon-close.vue";
import { DATE_FILTER, DATE_SHOW_FORMAT } from "@/utils/config";
import { generateDatefromFilter } from "@/utils/util";
import { RouterPath } from "@/utils/mixin";
import moment from "moment";
import { DATE_FORMAT } from "@/utils/config";

export default {
  name: "MiniCalenderPool",
  components: {
    IconClose,
  },
  props: {
  isMonthView: {
    type: Boolean,
    default: false,
  }
},
  mixins: [RouterPath],
  methods: {
    getCategoryName(filter) {
      for (let key of this.categorylist.keys) {
        let filtered = this.categorylist.data[key].terms.find(
          (item) => item.id == filter
        );
        if (filtered) {
          return filtered.name;
        }
      }

      return "";
    },
    onClearAll() {
      this.setLoading(true);
      this.setSearch({ search: "" });
      this.setFilter([]);
      this.setSelectedMonth("");
      this.$store.state.selectedCategories = {};
      this.setDateRange({
        type: "",
        start: "",
        end: "",
      });
      const currentDate = moment().format("YYYY-MM-DD");
      getFilteredEvents(currentDate, "", "", 1, "")
        .then((response) => {
          if (response) {
            const data = response.data ? response.data : [];
            this.setEventList({ eventlist: data, total: response.query.total });
          }
          this.setLoading(false);
        })
        .catch(() => {
          this.setLoading(false);
        });
      this.$emit("resetall-month-view");
      this.$router.push("/");
    },
    onClear() {
      this.setLoading(true);
      const currentDate = moment().format("YYYY-MM-DD");
      const dateRange = this.date_range || {};
      const startDate = dateRange.start || currentDate;
      const endDate = dateRange.end || "";
      const queryString = Object.entries(this.$store.state.selectedCategories || {})
      .flatMap(([key, terms]) => terms.map((term) => `${key}=${term}`))
      .join("&");
      const filtersQueryString = queryString || "";
      getFilteredEvents(startDate, endDate, filtersQueryString)
        .then((eventlist) => {
          this.setSearch({ search: "" });
          this.setEventList({
            eventlist: eventlist.data,
            total: eventlist.query.total,
          });
          this.setLoading(false);
        })
        .catch(() => {
          this.setLoading(false);
        });
    },
  onClearDate() {
    this.setLoading(true);
    const queryString = Object.entries(this.$store.state.selectedCategories || {})
      .flatMap(([key, terms]) => terms.map((term) => `${key}=${term}`))
      .join("&");
    const filtersQueryString = queryString || "";
    const currentDate = moment().format("YYYY-MM-DD");
    const currentMonth = moment().format("YYYY-MM");
    const searchTerm = this.search || "";
    this.setSelectedMonth(currentMonth);
    this.setDateManuallySelected(false);
    getFilteredEvents(currentDate, "", filtersQueryString, 1, searchTerm)
      .then((response) => {
        this.setDateRange({
          type: "",
          start: "",
          end: "",
        });
        if (response) {
          let data = response.data ? response.data : [];
          this.setEventList({ eventlist: data, total: response.query.total });
        }
        this.setLoading(false);
        this.$emit("reset-month-view");
      })
      .catch(() => {
        this.setLoading(false);
      });
  },
  onRemoveFilter(item) {
    const selectedCategories = JSON.parse(JSON.stringify(this.$store.state.selectedCategories));
    // Remove the term (item) from the selectedCategories
    Object.keys(selectedCategories).forEach((key) => {
      if (selectedCategories[key]) {
        const index = selectedCategories[key].indexOf(item);
        if (index > -1) {
          selectedCategories[key].splice(index, 1);
          this.filter = [item];
          if (selectedCategories[key].length === 0) {
            delete selectedCategories[key]; // Removing the key if no terms remains
          }
          // Only dispatch Vuex action if the key still exists
          if (selectedCategories[key]) {
            this.$store.dispatch("updateSelectedCategories", {
              key: key,
              terms: selectedCategories[key], // Pass the updated terms
            });
          } else {
            // Dispatch Vuex action to explicitly clear the key
            this.$store.dispatch("updateSelectedCategories", {
              key: key,
              terms: [],
            });
          }
        }
      }
    });
    const updateFilters = this.$store.state.selectedCategories
      ? Object.values(this.$store.state.selectedCategories).flat()
      : [];
    const queryString = Object.entries(this.$store.state.selectedCategories || {})
    .flatMap(([key, terms]) => terms.map((term) => `${key}=${term}`))
    .join("&");

    const filtersQueryString = queryString || "";
    const searchTerm = this.search || "";
    const currentDate = moment().format(DATE_FORMAT);
    const startDate = this.date_range.start || currentDate;
    const endDate = this.date_range.end || "";
    this.setLoading(true);
    getFilteredEvents(startDate, endDate, filtersQueryString, 1, searchTerm)
      .then((response) => {
        if (response) {
          const data = response.data ? response.data : [];
          this.setEventList({ eventlist: data, total: response.query.total });
        }
        this.setFilter(updateFilters);
        this.setLoading(false);
      })
      .catch(() => {
        this.setLoading(false);
      });
  },
    ...mapActions([
      "setEventList",
      "setSearch",
      "setClearAll",
      "setLoading",
      "setFilter",
      "setDateRange",
      "setSelectedMonth",
      "setDateManuallySelected",
    ]),
  },
  computed: {
    getDateFilterName() {
      if (this.date_range.type == "custom_range") {
        if (this.date_range.start == this.date_range.end) {
          return moment(this.date_range.start).format(DATE_SHOW_FORMAT);
        }
        if (!this.date_range.start) {
          return "";
        } else if (this.date_range.start == this.date_range.end) {
          return moment(this.date_range.start).format(DATE_SHOW_FORMAT);
        } else {
          return (
            moment(this.date_range.start).format(DATE_SHOW_FORMAT) +
            " to " +
            moment(this.date_range.end).format(DATE_SHOW_FORMAT)
          );
        }
      }

      let item = DATE_FILTER.list.find(
        (item) => item.id == this.date_range.type
      );
      if (item) {
        return generateDatefromFilter(item.id);
      }

      return "";
    },
    ...mapGetters([
      "total",
      "eventlist",
      "search",
      "date_range",
      "filter",
      "categorylist",
      "isDateManuallySelected",
      "isMonthView",
    ]),
  },
};
</script>
